import { render } from "./CreditRequestReferences.vue?vue&type=template&id=20b2e27c"
import script from "./CreditRequestReferences.vue?vue&type=script&lang=js"
export * from "./CreditRequestReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__